import { render } from "./SMS.vue?vue&type=template&id=0ac0d780&scoped=true"
import script from "./SMS.vue?vue&type=script&lang=js"
export * from "./SMS.vue?vue&type=script&lang=js"

import "./SMS.vue?vue&type=style&index=0&id=0ac0d780&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac0d780"]])

export default __exports__